import { render, staticRenderFns } from "./SectionEvotor.vue?vue&type=template&id=a327644a&"
import script from "./SectionEvotor.vue?vue&type=script&lang=js&"
export * from "./SectionEvotor.vue?vue&type=script&lang=js&"
import style0 from "./SectionEvotor.vue?vue&type=style&index=0&lang=scss&module=w&"




function injectStyles (context) {
  
  this["w"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports